// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-simple-checkbox .theme--light.v-icon[data-v-0dbfc42c] {\r\n  color: #005eb8 !important;\n}\r\n", ""]);
// Exports
module.exports = exports;
